<div *ngIf="showDeleteAlert" class="print-history-popup" style="z-index: 9999999;">
    <div class="print-history-popup-body">
      <h2 class="popup-title">  {{"Delete " +(toDeleteDocument.title)+ " document from " +
        (toDeleteDocument.CreationTime | date : "d/M/yy, HH:mm a")
        }}?</h2>
        <div style="display: flex; justify-content: space-around;">
            <button (click)="deleteDocument()">
              Yes
            </button>
            <button
              (click)="toDeleteDocument = null; showDeleteAlert = false"
              style="margin-left: 2em"
            >
              No
            </button>
          </div>
      <button
        (click)="showDeleteAlert = false;toDeleteDocument = null;"
        class="print-history-popup-close"
        aria-label="close popup"
      ></button>
    </div>
  </div>
<div class="t-popup popup-patientDetails">

    <div class="t-popup-close"></div>

    <div class="t-popup-frame">
        <div class="t-popup-body">

            <button class="t-btn-popup-close" aria-label="close popup" (click)="close()"></button>

            <h2>

            </h2>

            <!-- <div>
                <input class="custom-file-upload" type="file" (change)="onFileSelected($event)">
            </div> -->

            <div class="file-input-container">
                <input type="file" id="fileInput" class="file-input" (change)="onFileSelected($event)" />
                <label for="fileInput" class="file-label" (click)="errorUploadDocs=null;selectedFile=null">Add File</label>
            </div>
            <div *ngIf="errorUploadDocs">
                <h3>{{errorUploadDocs}}</h3>
            </div>

            <div *ngIf="selectedFile" style="display: flex;
            justify-content: center;
            gap: 1em;
            margin-top: 2em;">
                <p> <strong>
                        File Name:
                    </strong>
                    {{ selectedFile.name }}</p>
                <p>
                    <strong>
                        File Size:
                    </strong>
                    {{ selectedFile.size |fileSize }} 
                </p>

            </div>
            <div *ngIf="selectedFile" style="display: flex; justify-content: center;
            align-items: center;
            gap: 1em;
            margin-top: 2em;">
                <label><strong>Title:</strong></label>
                <div class="cervical-row" style="width: 30%;">
                        <textarea class="scroller"  maxlength="33" style="background-image: linear-gradient(to right, rgb(225, 235, 235) 0%, rgb(237, 244, 244) 100%);border-radius: 0.75em;min-height: 2.5em;
                        " [(ngModel)]="documentTitle" rows="1"></textarea>
                </div>
                <label><strong>Comments:</strong></label>
                <div class="cervical-row" style="width: 30%;">
                    <textarea class="scroller"  maxlength="66" style="background-image: linear-gradient(to right, rgb(225, 235, 235) 0%, rgb(237, 244, 244) 100%);border-radius: 0.75em;min-height: 2.5em;
                    " [(ngModel)]="documentComments" rows="1"></textarea>
                </div>
                <button *ngIf="!errorUploadDocs" class="confirm--btn" style='margin-left: 2em' (click)="saveDocument()">
                    Save
                </button>
            </div>


            <div class="l-flex patient-item-n " *ngFor="let document of documents; index as i ">

                <button class="w100 " style="cursor:pointer;" >

                    <div class="l-table h100">
                        
                        <span class="l-td-m patient-item-cell  " style="width: 5em;" (click)="openDocument(document.AutoIndex)">
                             <strong>{{i+1}}</strong>
                        </span>
                        <span class="l-td-m patient-item-cell ">
                            <strong> name :</strong> {{ document.title}}
                        </span>

                        <span class="l-td-m patient-item-cell " (click)="openDocument(document.AutoIndex)">
                            <strong>
                                file type:    
                            </strong>
                            {{document.fileType}}
                        </span>
                        <span class="l-td-m patient-item-cell " (click)="openDocument(document.AutoIndex)">
                            <strong>

                                comment:
                            </strong>
                            {{document.comments}}
                        </span>
                        <span class="l-td-m patient-item-cell " (click)="openDocument(document.AutoIndex)">
                            <strong>
                            creation time:
                            </strong>
                            {{document.CreationTime |date : "dd/MM/yyyy"}}
                        </span>
                  
                        <span class="l-td-m patient-item-cell w5 ">
                            <img
                            style="cursor: pointer;"
                            matTooltip="Delete Document"
                            height="35em"
                            src="../../assets/icons/delete-blue.svg"
                            (click)="showDeleteAlert=true;toDeleteDocument=document"
                          />
                        </span>



                    </div>

                </button>


            </div>
        </div>



    </div>
</div>